import React, { useState, useEffect, useRef, FC } from 'react';
import Chip from '@mui/material/Chip';
import TagIcon from '@mui/icons-material/Sell';
import AddIcon from '@mui/icons-material/Add';
import TwTooltip from '../TwTooltip/TwTooltip';
import TwSearchCreateLoadTag from './TwSearchCreateLoadTag';
import Box from '@mui/material/Box';
import { EntityType } from '../../redux/Global.model';

interface TwLoadEmptyOrAddTagProps {
  entity: EntityType;
  tagsExist: boolean;
  loadId: string;
  tripId?: string;
  editTagOpen: boolean;
  onAddTagOpen?: () => void;
  reloadData?: () => void;
}

const TwLoadEmptyOrAddTag: FC<TwLoadEmptyOrAddTagProps> = ({
  entity,
  tagsExist,
  loadId,
  tripId,
  editTagOpen,
  reloadData,
  onAddTagOpen
}): JSX.Element => {
  const [openSearch, setOpenSearch] = useState<boolean>(false);
  const addTagRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (editTagOpen) {
      setOpenSearch(false);
    }
  }, [editTagOpen]);

  const handleOpenSearchCreate = (): void => {
    setOpenSearch(true);
    onAddTagOpen && onAddTagOpen();
  };

  return (
    <Box sx={{ position: 'relative' }}>
      <Chip
        className={`load-tags__empty-tag ${tagsExist && 'load-tags__noLabel'}`}
        label={!tagsExist ? 'No tags' : ''}
        icon={!tagsExist ? <TagIcon className="load-tags__tag-icon" /> : undefined}
        onDelete={handleOpenSearchCreate}
        deleteIcon={
          <TwTooltip title="Add tags">
            <AddIcon
              className={!tagsExist ? 'load-tags__empty-tag__add-icon' : 'load-tags__add-icon'}
            />
          </TwTooltip>
        }
        variant="outlined"
        ref={addTagRef}
      />

      <TwSearchCreateLoadTag
        entity={entity}
        open={openSearch}
        changeOpen={setOpenSearch}
        anchor={addTagRef.current}
        loadId={loadId}
        tripId={tripId}
        reloadData={reloadData}
      />
    </Box>
  );
};

export default TwLoadEmptyOrAddTag;
